/**
 * Batesky policy document, hosted verbatim from the source content.
 * Do not reword; kept as-is per product requirement.
 */
export const networkServicesPrivacyPolicy = {
  title: "Bluesky AT Protocol Network Services Privacy Policy",
  lastUpdated: "July 7, 2025",
  body: `Batesky is built on Bluesky and AT Protocol. To review the respective policies please visit the Bluesky AT Protocol Network Services Privacy Notice [https://bsky.social/about/support/network-services-privacy-policy](https://bsky.social/about/support/network-services-privacy-policy). 
`,
}
